__webpack_require__.p = "/EduCaptuARe/";